import { combineReducers, configureStore } from "@reduxjs/toolkit";

import achPayments from "../modules/achPayments/oneTime.slice";
import scheduledACHPayments from "../modules/achPayments/scheduled.slice";
import onboarding from "../modules/onboarding/slice";

import institution from "./slices/institution.slice";
import user from "./slices/user.slice";
import accounts from "./accounts/slice";
import accountHolds from "./accountHolds/slice";
import accountSorting from "./slices/accountSorting.slice";
import endToEndTest from "./slices/endToEndTest.slice";
import featureStatus from "./slices/featureStatus.slice";
import fedwireTemplates from "./fedwireTemplates/slice";
import swiftwireTemplates from "./swiftwireTemplates/slice";
import wires from "./wires/slice";
import limits from "./limits/slice";
import recipients from "./recipients/slice";
import savvyMoney from "./savvyMoney/slice";
import cardLimitIncrease from "./cardLimitIncrease/slice";
import userAlerts from "./alerts/slice";
import userSavedSearches from "./alerts/custom/slice";
import achCompanies from "./achCompanies/slice";
import paymentActivity from "./paymentActivity/slice";
import bulkPayments from "./bulkPayments/slice";
import bulkTemplates from "./bulkTemplates/slice";
import fileImportPayments from "./fileImportPayments/slice";
import fileImportActivity from "./fileImportActivity/slice";
import dualApprovals from "./dualApprovals/slice";
import transfers from "./transfers/slice";
import subscriptions from "./subscriptions/slice";
import quickActions from "./quickActions/slice";
import subscriptionMetadata from "./subscriptionMetadata/slice";
import merchants from "./merchants/slice";
import cardLinkedOffers from "./cardLinkedOffers/slice";
import networkRequests from "./network/request.slice";
import networkResponses from "./network/response.slice";
import wireImportBatches from "./wireImport/slice";
import holidays from "./holidays/slice";

export const reducers = {
  ...institution,
  ...user,
  ...accounts,
  ...accountSorting,
  ...endToEndTest,
  ...featureStatus,
  ...fedwireTemplates,
  ...swiftwireTemplates,
  ...wires,
  ...limits,
  ...onboarding,
  ...recipients,
  ...savvyMoney,
  ...cardLimitIncrease,
  ...achCompanies,
  ...achPayments,
  ...scheduledACHPayments,
  ...dualApprovals,
  ...paymentActivity,
  ...bulkPayments,
  ...bulkTemplates,
  ...fileImportPayments,
  ...fileImportActivity,
  ...transfers,
  ...userAlerts,
  ...userSavedSearches,
  ...subscriptions,
  ...quickActions,
  ...subscriptionMetadata,
  ...merchants,
  ...cardLinkedOffers,
  ...accountHolds,
  ...networkRequests,
  ...networkResponses,
  ...wireImportBatches,
  ...holidays,
};

const rootReducer = combineReducers(reducers);

const defaultStore = configureStore({
  reducer: rootReducer,
});

export const DEFAULT_STATE = defaultStore.getState();

export type AppDispatch = typeof defaultStore.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
export type PreloadedState = Partial<RootState>;

export const setupStore = (preloadedState?: PreloadedState) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};
